/**
 * Pointer input for the board canvas. Pointer Events unify mouse and touch;
 * a tap/click is reported in canvas CSS-pixel coordinates and mapped to a
 * board square by the caller via coordinates.posFromPoint.
 */

export type BoardTapHandler = (x: number, y: number) => void;

export function attachBoardInput(canvas: HTMLCanvasElement, onTap: BoardTapHandler): void {
  canvas.addEventListener('pointerdown', (event: PointerEvent) => {
    if (event.button !== 0 && event.pointerType === 'mouse') return;
    const rect = canvas.getBoundingClientRect();
    onTap(event.clientX - rect.left, event.clientY - rect.top);
    event.preventDefault();
  });
}

export type BoardHoverHandler = (x: number, y: number) => void;

/** Mouse-only hover reporting (touch pointers get no sticky highlight). */
export function attachBoardHover(
  canvas: HTMLCanvasElement,
  onMove: BoardHoverHandler,
  onLeave: () => void,
): void {
  canvas.addEventListener('pointermove', (event: PointerEvent) => {
    if (event.pointerType !== 'mouse') return;
    const rect = canvas.getBoundingClientRect();
    onMove(event.clientX - rect.left, event.clientY - rect.top);
  });
  canvas.addEventListener('pointerleave', onLeave);
}
